var Handlebars = require("../../../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "\n    <div class=\"note-opts-row note-opts-row-txt-stamp-variable\">\n        <label class=\"note-opts-lbl-left txt-stamp-variable-lbl\">"
    + alias2(alias1((depth0 != null ? depth0.keyNoSymbol : depth0), depth0))
    + ":</label>\n        <input class=\"txt-stamp-variable-input placeholder\" type=\"text\" value=\""
    + alias2(alias1((depth0 != null ? depth0.value : depth0), depth0))
    + "\" maxlength=\"1000\"\n               placeholder=\""
    + alias2(alias1((depth0 != null ? depth0.keyNoSymbol : depth0), depth0))
    + "\" title=\""
    + alias2(alias1((depth0 != null ? depth0.keyNoSymbol : depth0), depth0))
    + "\" data-key=\""
    + alias2(alias1((depth0 != null ? depth0.key : depth0), depth0))
    + "\" required>\n    </div>\n\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"note-opts-row\">\n    <span>Variables:</span>\n</div>\n\n\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.inputs : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/views/note/textStamp/variableInputs/template.hbs
 ** module id = 330
 ** module chunks = 0
 **/